import { CommonModule } from '@angular/common';
import { Component, inject, Input } from '@angular/core';
import { MatTooltipModule } from '@angular/material/tooltip';

import { EventTypes } from 'src/app/core/constants/event-types';
import { DynamicTabService } from 'src/app/core/services/dynamic-tab.service';
import { ThemeColorType } from 'src/app/core/types/theme-color-type.type';
import { ThemeColorDirective } from 'src/app/core/utils/theme/theme-color.directive';
import { TranslationModule } from 'src/app/i18n';
import { BasePageComponent } from 'src/app/pages/shared/base';

@Component({
    selector: 'page-header-btn',
    templateUrl: './page-header-btn.component.html',
    imports: [
        CommonModule,
        ThemeColorDirective,
        MatTooltipModule,
        TranslationModule,
    ]
})
export class PageHeaderBtnComponent extends BasePageComponent {
  //#region property
  dynamicTabService = inject(DynamicTabService);

  @Input() title: string = '';
  @Input() icon: string = '';
  @Input() iconSize: string = 'mdi-20px';
  @Input() btnColor: ThemeColorType;
  @Input() name: string = '';
  //#endregion

  openPage(tabName: string) {
    try {
      this.dynamicTabService.setNewTab('');
      this.dynamicTabService.setNewTab(tabName);
      this.dynamicTabService.setActiveTab(tabName);
    } catch (error) {
      this.loggerService.logError(this.tagName, error, EventTypes.dashboard);
    }
  }
}
